import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue";
var _hoisted_1 = {
  class: "admin-main"
};
var _hoisted_2 = {
  class: "admin-manage"
};
var _hoisted_3 = {
  class: "admin-manage-header"
};
var _hoisted_4 = {
  class: "admin-manage-list"
};
var _hoisted_5 = {
  class: "item-main"
};
var _hoisted_6 = ["src"];
var _hoisted_7 = {
  class: "item-name"
};
var _hoisted_8 = {
  class: "admin-manage-list-item"
};
var _hoisted_9 = {
  class: "admin-manage-list-item"
};
var _hoisted_10 = {
  key: 0,
  class: "admin-mute-all"
};
var _hoisted_11 = {
  class: "admin-mute-all-title"
};
var _hoisted_12 = {
  class: "admin-mute-all-content"
};
var _hoisted_13 = {
  key: 1,
  class: "admin-mute"
};
var _hoisted_14 = {
  class: "admin-mute-header"
};
var _hoisted_15 = {
  class: "admin-mute-list"
};
var _hoisted_16 = {
  class: "item-main"
};
var _hoisted_17 = ["src"];
var _hoisted_18 = {
  class: "item-name"
};
var _hoisted_19 = {
  class: "admin-mute-list-item"
};
var _hoisted_20 = {
  class: "admin-mute-list-item"
};
import { TUITranslateService } from '@tencentcloud/chat-uikit-engine';
import { watchEffect, ref } from '../../../adapter-vue';
import Slider from '../../common/Slider/index.vue';
import Icon from '../../common/Icon.vue';
import plusSVG from '../../../assets/icon/plus.svg';
import minusSVG from '../../../assets/icon/minus.svg';
export default /*@__PURE__*/_defineComponent({
  __name: 'manage-admin',
  props: {
    member: {
      type: Object,
      default: () => {}
    },
    isSetMuteTime: {
      type: Boolean,
      default: () => false
    },
    currentGroup: {
      type: Object,
      default: () => {}
    }
  },
  emits: ['addAdmin', 'removeAdmin', 'setAllMuteTime', 'addMute', 'removeMute', 'close'],
  setup(__props, _ref) {
    var {
      emit: __emit
    } = _ref;
    var props = __props;
    var isAdminSetMuteTime = ref(false);
    var memberAdmin = ref({
      admin: [],
      member: [],
      muteMember: []
    });
    var currentGroupAdmin = ref();
    watchEffect(() => {
      memberAdmin.value = props.member;
      isAdminSetMuteTime.value = props.isSetMuteTime;
      currentGroupAdmin.value = props.currentGroup;
    });
    var emits = __emit;
    var addAdmin = () => {
      emits('addAdmin');
    };
    var removeAdmin = () => {
      emits('removeAdmin');
    };
    var setAllMuteTime = value => {
      emits('setAllMuteTime', value);
    };
    var addMute = () => {
      emits('addMute');
    };
    var removeMute = () => {
      emits('removeMute');
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, _toDisplayString(_unref(TUITranslateService).t("TUIGroup.\u7FA4\u7BA1\u7406\u5458")), 1), _createElementVNode("ul", _hoisted_4, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(memberAdmin).admin, (item, index) => {
        return _openBlock(), _createElementBlock("li", {
          key: index,
          class: "admin-manage-list-item"
        }, [_createElementVNode("div", _hoisted_5, [_createElementVNode("img", {
          class: "item-main-avatar",
          src: item.avatar || 'https://www.bio-cloud.com.cn:8022/img/2023-03-20/156C7EDA-15DE-DD54-1818-B845B202D788.png',
          onerror: "this.onerror=null;this.src='https://www.bio-cloud.com.cn:8022/img/2023-03-20/156C7EDA-15DE-DD54-1818-B845B202D788.png'"
        }, null, 8, _hoisted_6)]), _createElementVNode("div", _hoisted_7, _toDisplayString(item.nick || item.userID), 1)]);
      }), 128)), _createElementVNode("li", _hoisted_8, [_createElementVNode("div", {
        class: "item-main",
        onClick: addAdmin
      }, [_createVNode(Icon, {
        file: _unref(plusSVG),
        width: "16px",
        height: "16px"
      }, null, 8, ["file"])])]), _createElementVNode("li", _hoisted_9, [_unref(memberAdmin).admin.length > 0 ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "item-main",
        onClick: removeAdmin
      }, [_createVNode(Icon, {
        file: _unref(minusSVG),
        width: "16px",
        height: "16px"
      }, null, 8, ["file"])])) : _createCommentVNode("", true)])])]), _unref(isAdminSetMuteTime) ? (_openBlock(), _createElementBlock("div", _hoisted_10, [_createElementVNode("div", null, [_createElementVNode("div", _hoisted_11, _toDisplayString(_unref(TUITranslateService).t("TUIGroup.\u5168\u5458\u7981\u8A00")), 1), _createElementVNode("div", _hoisted_12, _toDisplayString(_unref(TUITranslateService).t("TUIGroup.\u5168\u5458\u7981\u8A00\u5F00\u542F\u540E\uFF0C\u53EA\u5141\u8BB8\u7FA4\u4E3B\u548C\u7BA1\u7406\u5458\u53D1\u8A00\u3002")), 1)]), _createVNode(Slider, {
        open: _unref(currentGroupAdmin).muteAllMembers,
        onChange: setAllMuteTime
      }, null, 8, ["open"])])) : _createCommentVNode("", true), _unref(isAdminSetMuteTime) ? (_openBlock(), _createElementBlock("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, _toDisplayString(_unref(TUITranslateService).t("TUIGroup.\u5355\u72EC\u7981\u8A00\u4EBA\u5458")), 1), _createElementVNode("ul", _hoisted_15, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(memberAdmin).muteMember, (item, index) => {
        return _openBlock(), _createElementBlock("li", {
          key: index,
          class: "admin-mute-list-item"
        }, [_createElementVNode("div", _hoisted_16, [_createElementVNode("img", {
          class: "item-main-avatar",
          src: item.avatar || 'https://www.bio-cloud.com.cn:8022/img/2023-03-20/156C7EDA-15DE-DD54-1818-B845B202D788.png',
          onerror: "this.onerror=null;this.src='https://www.bio-cloud.com.cn:8022/img/2023-03-20/156C7EDA-15DE-DD54-1818-B845B202D788.png'"
        }, null, 8, _hoisted_17)]), _createElementVNode("div", _hoisted_18, _toDisplayString(item.nick || item.userID), 1)]);
      }), 128)), _createElementVNode("li", _hoisted_19, [_createElementVNode("div", {
        class: "item-main",
        onClick: addMute
      }, [_createVNode(Icon, {
        file: _unref(plusSVG),
        width: "16px",
        height: "16px"
      }, null, 8, ["file"])])]), _createElementVNode("li", _hoisted_20, [_unref(memberAdmin).muteMember.length > 0 ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "item-main",
        onClick: removeMute
      }, [_createVNode(Icon, {
        file: _unref(minusSVG),
        width: "16px",
        height: "16px"
      }, null, 8, ["file"])])) : _createCommentVNode("", true)])])])) : _createCommentVNode("", true)]);
    };
  }
});